import { useMemo } from "react";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import { LangstonParameterSchema } from "../LangstonParameterSchema";

const PHET_SIMULATION = "PHET_SIMULATION";

/**
 * Hook that filters content type values based on experiment flags.
 * Currently filters PhET Simulations based on the phet_simulation_search_filter experiment.
 *
 * @returns {Array} Filtered array of content type values
 */
export const useContentTypeValues = () => {
  const [phetExperimentValue] = useGetUserExperimentSegment(
    "phet_simulation_search_filter",
  );

  const contentTypeValues = useMemo(() => {
    const allValues = LangstonParameterSchema.content_types.values;
    const isPhetEnabled = phetExperimentValue === "on";

    // Filter out PHET_SIMULATION if user is not in the experiment
    return allValues.filter((contentType) =>
      contentType.value === PHET_SIMULATION ? isPhetEnabled : true,
    );
  }, [phetExperimentValue]);

  return contentTypeValues;
};
